import React, { useState, useEffect } from 'react';

const ZoneLayout = ({ children, ticker = '', showClock = true, showWeather = false, weatherData = null }) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  };

  return (
    <div className="w-full h-full flex flex-col bg-black" data-testid="zone-layout">
      {/* Main content area */}
      <div className="flex flex-1 min-h-0">
        {/* Main slideshow zone */}
        <div className="flex-1 relative overflow-hidden">
          {children}
        </div>

        {/* Right sidebar - Clock/Date/Weather */}
        {showClock && (
          <div className="w-48 bg-slate-950 flex flex-col items-center justify-center border-l border-slate-800 flex-shrink-0">
            <div className="text-center px-4">
              <div className="text-3xl font-bold text-white tracking-tight">
                {formatTime(time)}
              </div>
              <div className="text-slate-400 text-sm mt-1">
                {formatDate(time)}
              </div>
              {weatherData && (
                <div className="mt-4 pt-4 border-t border-slate-800">
                  <div className="text-2xl font-bold text-cyan-400">
                    {Math.round(weatherData.temp)}°F
                  </div>
                  <div className="text-slate-400 text-xs mt-1">
                    {weatherData.description || ''}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Bottom ticker zone */}
      {ticker && (
        <div className="h-12 bg-slate-900 border-t border-slate-800 flex items-center overflow-hidden flex-shrink-0">
          <div className="animate-ticker whitespace-nowrap flex items-center">
            <span className="text-white text-base font-medium mx-12">{ticker}</span>
            <span className="text-slate-500 mx-4">|</span>
            <span className="text-white text-base font-medium mx-12">{ticker}</span>
            <span className="text-slate-500 mx-4">|</span>
            <span className="text-white text-base font-medium mx-12">{ticker}</span>
          </div>
          <style>{`
            @keyframes ticker {
              0% { transform: translateX(0); }
              100% { transform: translateX(-33.33%); }
            }
            .animate-ticker {
              animation: ticker 30s linear infinite;
            }
          `}</style>
        </div>
      )}
    </div>
  );
};

export default ZoneLayout;
